import React, {
  useState,
  useEffect,
  useLayoutEffect,
  useMemo,
  createRef,
  useRef,
  useCallback,
} from "react";
import ReactDOM from "react-dom"; // Added for Portal
import weeklyStyles from "../EventShiftsView/WeeklyCalendarSchedular.module.scss";
import { withTranslation } from "react-i18next";
import {
  encodeId,
  isMobileTab,
  titleWordLimit,
  handleError,
  handleSuccess,
  generateWeek,
} from "utils";
import * as moment from "moment";
import {
  getSchedularNotes,
  deleteSchedularNote,
  getEventListForAssigner,
  duplicateSchedulerEvent,
  eventPublished,
  getAssignedEmployess,
  useCreateUpdateSchedulerEventMutation,
  getEventListDetails,
} from "repositories/scheduler-repository";
import { buildDuplicateSchedulerEventPayload } from "./duplicateSchedulerEvent.utils";
import { useMultipleDuplicatesFlyout } from "./useMultipleDuplicatesFlyout";
import { useAssignUsersFromCard } from "./useAssignUsersFromCard";
import toast from "react-hot-toast";
import Loader from "components/Loader";
import { useHistory, useLocation } from "react-router-dom";
import { useQueryClient } from "react-query";
import EmptySchedulerCellAdd from "accountOwner/pages/Scheduler/components/EmptySchedulerCellAdd";
import constants, {
  getSchedulerStatusById,
} from "../../../../../../../constants";
import PublishEventModal from "accountOwner/pages/Scheduler/components/Modals/PublishEvent";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Row,
} from "reactstrap";
import { ThreeDots, ChevronLeft, ChevronRight } from "react-bootstrap-icons";
import {
  renderOfficeNameOrEnterprise,
  setterCustomSchduler,
  setterPublishOffices,
  matchedBothPatternValues,
  matchedBothDatesValues,
} from "accountOwner/pages/AddEvent/addEvents.functions";
import { addEditEventsConst } from "accountOwner/pages/AddEvent/addEvents.constants";
import EditOptionsModal, {
  editTypesVariables,
} from "accountOwner/pages/EditEvent/EditOptionsModal";
import { showTime } from "..";
import HolidayImage from "assets/images/early_on.svg";
import Text from "components/Text";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import styles from "../../../../Scheduler.module.scss";
import {
  canShowEventCardMenu,
  isSchedulerAllDaySlotEvent,
  isSchedulerTimedSlotEvent,
} from "accountOwner/pages/Scheduler/scheduler.function";
import { NoteView } from "./EventsShiftsMonthly";
import AddNotesModal from "../Modals/AddNotesModal";
import EditNotesModal from "../Modals/EditNotesModal";
import DeleteNotes from "../Modals/DeleteNotes";
import EventsShiftsWeeklyByStaff from "./EventsShiftsWeeklyByStaff";
import {
  EVENT_WEEKLY_LAYOUT,
  getEventShiftSelectionKey,
  isEventShiftSelected,
} from "./eventWeeklyLayout.constants";
import {
  canDragSchedulerEventWithUnassigned,
  isUnassignedSchedulerEvent,
} from "./unassignedEvents.utils";
import {
  collectDraftPublishItemsFromWeekData,
  filterEventsWorkspaceBySearch,
  shouldApplyEventsWorkspaceSearch,
  countSchedulerEventOccurrences,
} from "./eventsWorkspacePublish.utils";
import { collectClearableItemsFromWeekData } from "./eventsWorkspaceClear.utils";
import { useSimpleEventCardDelete } from "./useSimpleEventCardDelete";

const HOUR_HEIGHT = 80;
const getEventThemeClass = (event) => {
  const title = event.title?.toLowerCase() || "";
  if (title.includes("busy")) return "theme-orange";
  if (title.includes("call patients") || title.includes("follow-up"))
    return "theme-blue";
  return "theme-green";
};

function EventsShiftsWeekly({
  t,
  settotalEvents,
  currentDate,
  calendarView,
  selectedOfficeFilter,
  searchValue,
  upDateListonApply,
  handleSidebarToggle,
  isSidebarActive,
  viewSettingFilter = [],
  canAddShift,
  eventShiftFilter = [],
  isEnterpriseFilterActive = false,
  appliedPublishedDraftFilter = [],
  selectedEmpFilter = [],
  holidaysObject,
  setcurrentDate,
  toggleRefreshEventList,
  weeklyLayoutOption,
  bulkSelectMode,
  selectedEvents,
  isBulkActionLoading,
  handleEventSelectionToggle,
  handleSelectableEventsUpdate,
  onVisibleDraftEventsUpdate,
  onVisibleClearableItemsUpdate,
  showComingSoon,
  sortStaffBy,
}) {
  const {
    effectiveOwnerId: selectedOwnerId,
    profile,
    effectiveOwnerIdString,
    isOwner,
    isStaff,
    dataAccessValues,
  } = useAccountOwnerCommon();
  const history = useHistory();
  const { search } = useLocation();
  const createSchedulerEventMutation = useCreateUpdateSchedulerEventMutation();
  const popupRef = useRef(null); // Ref for the popup element
  const containerRef = useRef(null); // Ref for the table container
  const divRef = useRef(null);

  const canEditAndViewOthersData = useCallback(
    (officeId) => {
      if (isStaff) {
        return (
          dataAccessValues?.officeList?.some(
            (res) => res.officeId === officeId && res.isAdmin,
          ) || false
        );
      }
      return isOwner;
    },
    [isStaff, isOwner, dataAccessValues?.officeList],
  );

  const dateMatchForHighlight = useMemo(() => {
    const searchValue = new URLSearchParams(search).get(showTime);
    if (searchValue?.includes("NaN") || !search) {
      return null;
    }
    return new Date(+searchValue);
  }, [search]);

  // State
  const [isAddNotesModal, setIsAddNotesModal] = useState({
    visible: false,
    date: "",
    value: "",
  });
  const [deleteConfirmation, setdeleteConfirmation] = useState({
    visible: false,
    id: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isEventLoading, setIsEventLoading] = useState(false);
  const [isPublishEventModalOpen, setIsPublishEventModalOpen] = useState(false);
  const [isEditNotesModal, setIsEditNotesModal] = useState({ visible: false });
  const [weekData, setWeekData] = useState([]);
  const [index, setindex] = useState("");
  const [eventListData, setEventListData] = useState([]);
  const [isDraftPublistEventOpen, setIsDraftPublishEvetntOpen] =
    useState(false);
  const [noOfEmployeeAssigne, setNoOfEmployeeAssigne] = useState(0);
  const [eventId, seteventId] = useState("");
  const [draggedEvent, setDraggedEvent] = useState(null);
  const draggedEventRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [dragPreviewPosition, setDragPreviewPosition] = useState(null);
  const [editModalConfirmation, setEditModalConfirmation] = useState(false);
  const [pendingDragUpdate, setPendingDragUpdate] = useState(null);
  const [isDragDropLoading, setIsDragDropLoading] = useState(false);
  const [isEmpPopActive, setEmpPopupActive] = useState("");

  const isStaffNameWeeklyLayout =
    weeklyLayoutOption === EVENT_WEEKLY_LAYOUT.STAFF_NAME;

  // Refs and States for custom scrolling, sticky header, and dynamic height
  const [tableHeight, setTableHeight] = useState("auto");
  const scrollContainerRef = useRef(null);
  const headerRef = useRef(null);

  const {
    openEventMenuKey,
    closeEventMenuAndFlyout,
    createEventMenuToggleHandler,
    handleMultipleDuplicatesClick,
    renderMultipleDuplicatesFlyout,
  } = useMultipleDuplicatesFlyout({
    scrollContainerRef,
    menuStyles: styles,
    dropdownToggleSelector: `.${weeklyStyles["interactive-events-dropdown"]}`,
  });

  // --- START OF DYNAMIC HEIGHT CALCULATION ---
  useEffect(() => {
    const calculateDynamicHeight = () => {
      if (scrollContainerRef.current) {
        const rect = scrollContainerRef.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        // Using exactly the same proven logic from previous components
        const wrapper =
          scrollContainerRef.current.closest(".scheduler-tabs") ||
          scrollContainerRef.current.closest(".Dashboard_box") ||
          document.body;

        let limitBottom = viewportHeight;

        if (wrapper) {
          const wrapperRect = wrapper.getBoundingClientRect();
          if (wrapperRect.bottom < viewportHeight) {
            limitBottom = wrapperRect.bottom - 5;
          }
        }

        let computedHeight = limitBottom - rect.top - 20;

        if (computedHeight < 200) computedHeight = 200;

        setTableHeight(`${computedHeight}px`);
      }
    };

    // Calculate on mount and shortly after
    calculateDynamicHeight();
    const timeoutId = setTimeout(calculateDynamicHeight, 150);

    // Attach listeners
    window.addEventListener("resize", calculateDynamicHeight);
    window.addEventListener("scroll", calculateDynamicHeight, {
      passive: true,
    });

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", calculateDynamicHeight);
      window.removeEventListener("scroll", calculateDynamicHeight);
    };
    // Re-runs when the weekly layout toggles, because the calendar grid (and its
    // scroll container ref) only exists in the non staff-name layout.
  }, [isStaffNameWeeklyLayout]);
  // --- END OF DYNAMIC HEIGHT CALCULATION ---

  useEffect(() => {
    if (currentDate) {
      // Generate week from Sunday to Saturday
      const selectedStartWeek = moment(currentDate).startOf("week"); // Sunday
      const selectedEndWeek = moment(currentDate).endOf("week"); // Saturday
      const currentweekData = generateWeek(selectedStartWeek, selectedEndWeek);
      setWeekData(currentweekData);
    }
  }, [currentDate]);

  const days = useMemo(() => {
    return weekData.map((day) => ({
      date: day.mDate,
      momentDate: day.date,
      formattedDate: moment(day.date).format("YYYY-MM-DD"),
    }));
  }, [weekData]);

  const hours = useMemo(() => {
    const hourList = [];
    for (let i = 0; i <= 23; i++) {
      const hour = moment().hour(i).minute(0);
      hourList.push({
        label: hour.format("h A"),
        moment: hour,
        hour: i,
      });
    }
    return hourList;
  }, []);

  useEffect(() => {
    if (!isStaffNameWeeklyLayout && !isLoading) getNotes(currentDate);
    // eslint-disable-next-line
  }, [
    currentDate,
    selectedOwnerId,
    calendarView,
    upDateListonApply,
    isStaffNameWeeklyLayout,
  ]);

  useEffect(() => {
    if (isMobileTab() && isSidebarActive)
      handleSuccess(t("accountOwner.dateApply"));
    // eslint-disable-next-line
  }, [currentDate]);

  // UseLayoutEffect to dynamically position the popup within the container bounds
  useLayoutEffect(() => {
    if (isEmpPopActive?.id && popupRef.current && containerRef.current) {
      const popup = popupRef.current;
      const container = containerRef.current;
      const { top, left, height: triggerHeight } = isEmpPopActive.position;
      const popupRect = popup.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();

      const scrollX = window.scrollX;
      const scrollY = window.scrollY;

      // Calculate absolute boundaries of the container (table)
      const containerRight = containerRect.right + scrollX;
      const containerLeft = containerRect.left + scrollX;
      const containerBottom = containerRect.bottom + scrollY;

      let newLeft = left;
      let newTop = top;

      // 1. Horizontal Constraint: Keep within container width
      // If popup goes off the right edge of the table, shift it left
      if (newLeft + popupRect.width > containerRight) {
        newLeft = containerRight - popupRect.width - 10; // 10px padding
      }
      // Ensure it doesn't go off the left edge
      if (newLeft < containerLeft) {
        newLeft = containerLeft + 10;
      }

      // 2. Vertical Constraint: Keep within container height
      // If popup goes off the bottom of the table, flip it above the trigger
      if (newTop + popupRect.height > containerBottom) {
        // Calculate position above: (Trigger Top) - (Popup Height)
        // Trigger Top = (Trigger Bottom [which is 'top']) - (Trigger Height)
        newTop = top - (triggerHeight || 0) - popupRect.height;
      }

      popup.style.left = `${newLeft}px`;
      popup.style.top = `${newTop}px`;
    }
  }, [isEmpPopActive]);

  useEffect(() => {
    // Day/time weekly layout owns this data; staff-name layout reports its own count.
    if (isStaffNameWeeklyLayout || !eventListData.length) return;
    const allEventData = JSON.parse(JSON.stringify(eventListData));
    const selectedStartWeek = moment(currentDate).startOf("week");
    const selectedEndWeek = moment(currentDate).endOf("week");
    const currentweekData = generateWeek(selectedStartWeek, selectedEndWeek);

    if (
      shouldApplyEventsWorkspaceSearch(searchValue) &&
      allEventData?.length > 0
    ) {
      const updatedWeekData = currentweekData.map((day) => {
        const dayDateStr = moment(day.date).format("YYYY-MM-DD");
        const eventData = allEventData.find(
          (item) => dateFormater(item.date) === dayDateStr,
        );
        if (eventData) {
          const titleList = filterEventsWorkspaceBySearch(
            eventData.schedulerEvents || [],
            searchValue,
          );
          return {
            ...day,
            schedulerEvents: titleList || [],
            note: eventData.note || false,
            data: eventData.data || null,
            formattedDate: dayDateStr,
          };
        }
        return { ...day, schedulerEvents: [], note: false };
      });
      setWeekData(updatedWeekData);
    } else {
      const updatedWeekData = currentweekData.map((day) => {
        const dayDateStr = moment(day.date).format("YYYY-MM-DD");
        const eventData = allEventData.find(
          (item) => dateFormater(item.date) === dayDateStr,
        );
        if (eventData) {
          return {
            ...day,
            schedulerEvents: eventData.schedulerEvents || [],
            note: eventData.note || false,
            data: eventData.data || null,
            formattedDate: dayDateStr,
          };
        }
        return { ...day, schedulerEvents: [], note: false };
      });
      setWeekData(updatedWeekData);
    }
  }, [searchValue, eventListData, currentDate, isStaffNameWeeklyLayout]);

  const getNotes = async (_currentDate) => {
    try {
      setIsLoading(true);
      const start = moment(_currentDate).startOf("week").format("YYYY-MM-DD");
      const end = moment(_currentDate).endOf("week").format("YYYY-MM-DD");
      let response = await getSchedularNotes(start, end, selectedOwnerId);
      getEventListingForAssigner(start, end, response.data || []);
    } catch (e) {
      handleError(e);
    }
    setIsLoading(false);
  };

  const { isAssignLoading, openAssignUsersModal, renderAssignUsersModals } =
    useAssignUsersFromCard({
      t,
      ownerId: selectedOwnerId,
      canAddShift,
      isStaff,
      onSuccess: () => getNotes(currentDate),
    });

  const getEventListingForAssigner = async (start, end, notesArray) => {
    try {
      setIsEventLoading(true);
      let response = await getEventListForAssigner(
        selectedOwnerId,
        start,
        end,
        selectedOfficeFilter,
        selectedEmpFilter,
      );
      let eventsDates = response?.data || [];

      if (notesArray?.length) {
        eventsDates = eventsDates.map((item) => {
          notesArray.forEach((note) => {
            if (dateFormater(item.date) === dateFormater(note.date)) {
              item.note = true;
              item.data = note;
            }
          });
          return item;
        });
      }

      const startMoment = moment(start);
      const endMoment = moment(end);
      const currentweekData = generateWeek(startMoment, endMoment);

      const updatedWeekData = currentweekData.map((day) => {
        const dayDateStr = moment(day.date).format("YYYY-MM-DD");
        const eventData = eventsDates.find(
          (item) => dateFormater(item.date) === dayDateStr,
        );
        return eventData
          ? {
              ...day,
              schedulerEvents: eventData.schedulerEvents || [],
              note: eventData.note || false,
              data: eventData.data || null,
              formattedDate: dayDateStr,
            }
          : { ...day, schedulerEvents: [], note: false };
      });

      setWeekData(updatedWeekData);
      setEventListData([...eventsDates]);
    } catch (e) {
      handleError(e.message);
    }
    setIsEventLoading(false);
  };

  const onDuplicateEvent = async (event, requestedDate, count = 1) => {
    try {
      setIsLoading(true);
      await duplicateSchedulerEvent(
        buildDuplicateSchedulerEventPayload({
          schedulerEventId: event?.id,
          eventDate: requestedDate,
          duplicateCount: count,
        }),
      );
      handleSuccess(t("scheduler.duplicateSuccess"));
      closeEventMenuAndFlyout();
      getNotes(currentDate);
    } catch (error) {
      handleError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const { handleCardDeleteClick, renderSimpleDeleteConfirmModal } =
    useSimpleEventCardDelete({
      t,
      history,
      effectiveOwnerIdString,
      onSuccess: () => getNotes(currentDate),
    });

  const dateFormater = (date) => moment(date).format("YYYY-MM-DD");

  const getTimeInMinutes = (time) => {
    if (!time) return 0;
    const date = new Date(time);
    if (isNaN(date.getTime())) return 0;
    return date.getHours() * 60 + date.getMinutes();
  };

  /**
   * True when a timed event/shift overlaps the given hour slot [hour, hour+1).
   * @param {Array<object>} events
   * @param {number} hourIndex
   */
  const hourSlotHasEvent = (events, hourIndex) => {
    const slotStart = hourIndex * 60;
    const slotEnd = slotStart + 60;
    return (events || []).some((event) => {
      const startMin = getTimeInMinutes(event.startTime);
      const endMin = getTimeInMinutes(event.endTime);
      return startMin < slotEnd && endMin > slotStart;
    });
  };

  const snapTo15Minutes = useCallback((minutes) => {
    const snapped = Math.round(minutes / 15) * 15;
    return Math.max(0, Math.min(59, snapped));
  }, []);

  const calculateOverlapPositions = useCallback((events) => {
    if (!events || events.length === 0) return [];

    const sortedEvents = [...events].sort((a, b) => {
      const startA = getTimeInMinutes(a.startTime);
      const startB = getTimeInMinutes(b.startTime);
      if (startA !== startB) return startA - startB;
      const durA = getTimeInMinutes(a.endTime) - startA;
      const durB = getTimeInMinutes(b.endTime) - startB;
      return durB - durA;
    });

    const positions = [];
    const columns = [];

    sortedEvents.forEach((event) => {
      const start = getTimeInMinutes(event.startTime);
      const end = getTimeInMinutes(event.endTime);

      let colIndex = 0;
      while (true) {
        const col = columns[colIndex];
        if (!col) {
          columns[colIndex] = [event];
          break;
        }
        const isOverlapping = col.some((placedEvent) => {
          const pStart = getTimeInMinutes(placedEvent.startTime);
          const pEnd = getTimeInMinutes(placedEvent.endTime);
          return start < pEnd && end > pStart;
        });

        if (!isOverlapping) {
          col.push(event);
          break;
        }
        colIndex++;
      }

      positions.push({ event, colIndex });
    });

    return positions.map(({ event, colIndex }) => ({
      event,
      widthFactor: 1 / columns.length,
      leftOffsetFactor: colIndex / columns.length,
    }));
  }, []);

  const getFilteredWeekData = (listing) => {
    let filtered = listing;

    // Apply event/shift filter
    if (eventShiftFilter?.length) {
      const eventsFilter = eventShiftFilter.includes("event");
      const shiftFilter = eventShiftFilter.includes("shift");
      const shiftByOtherFilter = eventShiftFilter.includes("shift-others");
      filtered = filtered.map((day) => {
        if (!day.schedulerEvents) return day;
        return {
          ...day,
          schedulerEvents: day.schedulerEvents.filter((ev) => {
            if (eventsFilter && !ev.isShift) return true;
            if (
              shiftFilter &&
              ev.isShift &&
              (shiftByOtherFilter || ev.createdById === profile.id)
            )
              return true;
            if (
              shiftByOtherFilter &&
              ev.isShift &&
              ev.createdById !== profile.id
            )
              return true;
            return false;
          }),
        };
      });
    }

    // Apply published/draft status filter
    if (appliedPublishedDraftFilter?.length) {
      filtered = filtered.map((day) => {
        if (!day.schedulerEvents) return day;
        return {
          ...day,
          schedulerEvents: day.schedulerEvents.filter((ev) => {
            if (
              appliedPublishedDraftFilter.includes("published") &&
              !ev.isDraft
            )
              return true;
            if (appliedPublishedDraftFilter.includes("draft") && ev.isDraft)
              return true;
            return false;
          }),
        };
      });
    }

    // Apply company-wide (enterprise) filter
    if (isEnterpriseFilterActive) {
      filtered = filtered.map((day) => {
        if (!day.schedulerEvents) return day;
        return {
          ...day,
          schedulerEvents: day.schedulerEvents.filter(
            (e) => e.isEnterprise === true,
          ),
        };
      });
    }

    return filtered;
  };

  // Check if event can be dragged
  const canDragEvent = useCallback(
    (eventItem) => {
      const baseCanDrag = (item) => {
        const createdByMe = item.createdById === profile?.id;
        const createdByOthers =
          item?.isShift && profile?.id !== item?.createdById;

        if (item?.isShift) {
          if (createdByMe) {
            return true;
          }
          if (createdByOthers) {
            const isAdmin = profile?.isAdmin;
            const isAccountOwner =
              profile && profile?.role
                ? profile.role.systemRole === constants.systemRoles.accountOwner
                : false;
            if (isAccountOwner || isAdmin) {
              return true;
            }
          }
          return false;
        }

        if (
          item.agendaType === constants.agendaType.EVENT ||
          !item.agendaType
        ) {
          return createdByMe;
        }

        return false;
      };

      return canDragSchedulerEventWithUnassigned(eventItem, baseCanDrag);
    },
    [profile?.id, selectedOwnerId],
  );

  // Check if event is all-day
  const isAllDayEvent = useCallback((eventItem) => {
    return (
      eventItem.isAllDayEvent ||
      eventItem.isAllDayBusy ||
      !eventItem.startTime ||
      !eventItem.endTime
    );
  }, []);

  // Helper function to get time range from hours array
  const getTimeRange = useCallback(() => {
    const minHour = hours.length > 0 ? hours[0].hour : 0;
    const maxHour = hours.length > 0 ? hours[hours.length - 1].hour : 23;
    return {
      startTime: moment().hour(minHour).minute(0).second(0),
      endTime: moment().hour(maxHour).minute(59).second(59),
    };
  }, [hours]);

  // Helper function to check if time is within allowed range
  const isTimeWithinRange = useCallback((timeMoment, timeRange, baseDate) => {
    if (!timeMoment || !timeRange) return true;

    if (baseDate && !timeMoment.isSame(baseDate, "day")) {
      return false;
    }

    const timeInMinutes = timeMoment.hour() * 60 + timeMoment.minute();
    const rangeStartMinutes =
      timeRange.startTime.hour() * 60 + timeRange.startTime.minute();
    const rangeEndMinutes =
      timeRange.endTime.hour() * 60 + timeRange.endTime.minute();

    return (
      timeInMinutes >= rangeStartMinutes && timeInMinutes <= rangeEndMinutes
    );
  }, []);

  // Calculate new date and time from drop position with 15-minute snap
  const calculateNewDateTime = useCallback(
    (eventItem, dropX, dropY, cellElement, dayIndex, hourIndex) => {
      if (
        !cellElement ||
        dayIndex < 0 ||
        dayIndex >= weekData.length ||
        !eventItem
      ) {
        return null;
      }

      const cellRect = cellElement.getBoundingClientRect();
      const relativeY = dropY - cellRect.top;
      const cellHeight = cellRect.height;
      const minuteHeight = cellHeight / 60;
      const minutesFromHourStart = relativeY / minuteHeight;
      const exactMinutes = Math.round(minutesFromHourStart);
      const clampedMinute = snapTo15Minutes(exactMinutes);

      const targetDate = weekData[dayIndex];
      if (!targetDate) return null;

      const newDate = moment(targetDate.date);
      const newStartTime = moment(newDate)
        .hour(hourIndex)
        .minute(clampedMinute)
        .second(0);

      const timeRange = getTimeRange();

      if (!eventItem.startTime || !eventItem.endTime) {
        const durationMinutes = 60;
        const newEndTime = moment(newStartTime).add(durationMinutes, "minutes");

        if (
          !isTimeWithinRange(newStartTime, timeRange, newDate) ||
          !isTimeWithinRange(newEndTime, timeRange, newDate)
        ) {
          return { error: "timeRangeExceeded" };
        }
        return {
          newDate: newDate.toDate(),
          newStartTime: newStartTime.toDate(),
          newEndTime: newEndTime.toDate(),
          newStartTimeString: newStartTime.format("YYYY-MM-DDTHH:mm"),
          newEndTimeString: newEndTime.format("YYYY-MM-DDTHH:mm"),
        };
      }

      const originalStart = moment(eventItem.startTime);
      const originalEnd = moment(eventItem.endTime);
      const durationMinutes = originalEnd.diff(originalStart, "minutes");

      const newEndTime = moment(newStartTime).add(durationMinutes, "minutes");

      if (
        !isTimeWithinRange(newStartTime, timeRange, newDate) ||
        !isTimeWithinRange(newEndTime, timeRange, newDate)
      ) {
        return { error: "timeRangeExceeded" };
      }
      return {
        newDate: newDate.toDate(),
        newStartTime: newStartTime.toDate(),
        newEndTime: newEndTime.toDate(),
        newStartTimeString: newStartTime.format("YYYY-MM-DDTHH:mm"),
        newEndTimeString: newEndTime.format("YYYY-MM-DDTHH:mm"),
      };
    },
    [weekData, getTimeRange, isTimeWithinRange, snapTo15Minutes],
  );

  // Calculate new date for all-day events
  const calculateNewDateForAllDay = useCallback(
    (eventItem, dayIndex, originalDateString = null) => {
      if (dayIndex < 0 || dayIndex >= weekData.length) {
        return null;
      }

      const targetDate = weekData[dayIndex];
      if (!targetDate) return null;

      const newDate = moment(targetDate.date).startOf("day");

      let originalDate = null;
      if (originalDateString) {
        originalDate = moment(originalDateString).startOf("day");
      } else if (eventItem.date) {
        originalDate = moment(eventItem.date).startOf("day");
      } else if (eventItem.startTime) {
        originalDate = moment(eventItem.startTime).startOf("day");
      }

      if (originalDate && newDate.isSame(originalDate, "day")) {
        return null;
      }

      return {
        newDate: newDate.toDate(),
        newStartTime: newDate.startOf("day").toDate(),
        newEndTime: newDate.endOf("day").toDate(),
        newStartTimeString: newDate.startOf("day").format("YYYY-MM-DDTHH:mm"),
        newEndTimeString: newDate.endOf("day").format("YYYY-MM-DDTHH:mm"),
      };
    },
    [weekData],
  );

  const calculateDateChangePreservingTime = useCallback(
    (eventItem, dayIndex, originalDateString = null) => {
      if (
        dayIndex < 0 ||
        dayIndex >= weekData.length ||
        !eventItem?.startTime
      ) {
        return null;
      }

      const targetDate = weekData[dayIndex];
      if (!targetDate) return null;

      const newDate = moment(targetDate.date).startOf("day");
      let originalDate = null;
      if (originalDateString) {
        originalDate = moment(originalDateString).startOf("day");
      } else if (eventItem.startTime) {
        originalDate = moment(eventItem.startTime).startOf("day");
      }

      if (originalDate && newDate.isSame(originalDate, "day")) {
        return null;
      }

      const originalStart = moment(eventItem.startTime);
      const originalEnd = moment(eventItem.endTime);
      const newStartTime = newDate
        .clone()
        .hour(originalStart.hour())
        .minute(originalStart.minute())
        .second(originalStart.second());
      const durationMinutes = originalEnd.diff(originalStart, "minutes");
      const newEndTime = moment(newStartTime).add(durationMinutes, "minutes");

      return {
        newDate: newDate.toDate(),
        newStartTime: newStartTime.toDate(),
        newEndTime: newEndTime.toDate(),
        newStartTimeString: newStartTime.format("YYYY-MM-DDTHH:mm"),
        newEndTimeString: newEndTime.format("YYYY-MM-DDTHH:mm"),
      };
    },
    [weekData],
  );

  const filteredData = useMemo(
    () => getFilteredWeekData(weekData),
    [
      weekData,
      eventShiftFilter,
      appliedPublishedDraftFilter,
      isEnterpriseFilterActive,
      profile?.id,
    ],
  );

  useEffect(() => {
    if (isStaffNameWeeklyLayout) return;
    // Count every visible card occurrence after filters/search.
    const visibleEvents = [];
    filteredData.forEach((day) => {
      visibleEvents.push(...(day.schedulerEvents || []));
    });
    settotalEvents(countSchedulerEventOccurrences(visibleEvents));
  }, [filteredData, isStaffNameWeeklyLayout, settotalEvents]);

  useEffect(() => {
    if (isStaffNameWeeklyLayout) return;
    const eventsMap = {};
    filteredData.forEach((day) => {
      const requestedDate =
        day.formattedDate || moment(day.date).format("YYYY-MM-DD");
      (day.schedulerEvents || []).forEach((ev) => {
        const key = getEventShiftSelectionKey(ev.id, requestedDate);
        eventsMap[key] = {
          id: ev.id,
          date: moment(requestedDate).format("YYYY-MM-DD"),
          isDraft: ev.isDraft,
          isShift: Boolean(ev.isShift),
          publishAsEvent: ev.publishAsEvent,
          userId: null,
          isUnassigned: isUnassignedSchedulerEvent(ev),
        };
      });
    });
    handleSelectableEventsUpdate(eventsMap);
  }, [filteredData, isStaffNameWeeklyLayout, handleSelectableEventsUpdate]);

  const visibleDraftItemsForPublish = useMemo(() => {
    if (isStaffNameWeeklyLayout) return [];
    return collectDraftPublishItemsFromWeekData(filteredData);
  }, [filteredData, isStaffNameWeeklyLayout]);

  const visibleClearableItems = useMemo(() => {
    if (isStaffNameWeeklyLayout) return [];
    return collectClearableItemsFromWeekData(filteredData);
  }, [filteredData, isStaffNameWeeklyLayout]);

  useEffect(() => {
    if (isStaffNameWeeklyLayout || !onVisibleDraftEventsUpdate) return;
    onVisibleDraftEventsUpdate(visibleDraftItemsForPublish);
  }, [
    visibleDraftItemsForPublish,
    isStaffNameWeeklyLayout,
    onVisibleDraftEventsUpdate,
  ]);

  useEffect(() => {
    if (isStaffNameWeeklyLayout || !onVisibleClearableItemsUpdate) return;
    onVisibleClearableItemsUpdate(visibleClearableItems);
  }, [
    visibleClearableItems,
    isStaffNameWeeklyLayout,
    onVisibleClearableItemsUpdate,
  ]);

  // Get all-day events grouped by date
  const allDayEventsByDate = useMemo(() => {
    const allDayMap = {};
    filteredData.forEach((day) => {
      const dayDateKey = day.mDate || moment(day.date).format("MMM DD, ddd");
      const allDayEvents = (day.schedulerEvents || []).filter(
        isSchedulerAllDaySlotEvent,
      );
      if (allDayEvents.length > 0) {
        allDayMap[dayDateKey] = allDayEvents;
      }
    });
    return allDayMap;
  }, [filteredData]);

  const hasAnyHoliday = useMemo(() => {
    return days.some((day) => {
      const dayDateStr = moment(day.momentDate).format("DD-MM-YYYY");
      return !!holidaysObject[dayDateStr];
    });
  }, [days, holidaysObject]);

  // Helper to check if time changed
  const getTimeCheck = useCallback((alreadyTime, selectedTime) => {
    if (alreadyTime) {
      const selectedStartTime = moment(selectedTime);
      const alreadySelectedStartTime = moment(alreadyTime);
      if (
        selectedStartTime.hour() !== alreadySelectedStartTime.hour() ||
        selectedStartTime.minute() !== alreadySelectedStartTime.minute()
      ) {
        return true;
      }
      return false;
    } else {
      return true;
    }
  }, []);

  // Internal function to perform the actual update
  const performEventUpdate = useCallback(
    async (eventData, newDateTime, editType, originalRequestedDate = null) => {
      if (!newDateTime || !eventData) {
        toast.error(t("scheduler.invalidEventData"));
        return;
      }

      const requestedDateForCheck = originalRequestedDate
        ? originalRequestedDate
        : eventData.requestedDate
          ? moment(eventData.requestedDate).format("YYYY-MM-DD")
          : eventData.startTime
            ? moment(eventData.startTime).format("YYYY-MM-DD")
            : moment(eventData.date || newDateTime.newDate).format(
                "YYYY-MM-DD",
              );

      const dateChangedResult = matchedBothDatesValues({
        eventDetail: eventData,
        repeatedEndDate: eventData.repeatedEndDate
          ? moment(eventData.repeatedEndDate).toDate()
          : moment().add(3, "month").toDate(),
        requestedDate: requestedDateForCheck,
        eventDate: newDateTime.newDate,
      });

      const startTimeChanged = getTimeCheck(
        eventData.startTime,
        newDateTime.newStartTimeString,
      );
      const endTimeChanged = getTimeCheck(
        eventData.endTime,
        newDateTime.newEndTimeString,
      );

      const originalRequestedDateForParams = originalRequestedDate
        ? moment(originalRequestedDate).format("YYYY-MM-DDTHH:mm")
        : eventData.requestedDate
          ? moment(eventData.requestedDate).format("YYYY-MM-DDTHH:mm")
          : eventData.startTime
            ? moment(eventData.startTime).format("YYYY-MM-DDTHH:mm")
            : moment(newDateTime.newDate).format("YYYY-MM-DDTHH:mm");

      const requestedDateForDateCalc = originalRequestedDate
        ? moment(originalRequestedDate).toDate()
        : eventData.requestedDate
          ? moment(eventData.requestedDate).toDate()
          : eventData.startTime
            ? moment(eventData.startTime).toDate()
            : null;

      const eventDate = moment(newDateTime.newDate).toDate();

      // Check if the date actually changed (comparing dates only, ignoring time)
      const originalDateForComparison = requestedDateForDateCalc
        ? moment(requestedDateForDateCalc).startOf("day")
        : eventData.startTime
          ? moment(eventData.startTime).startOf("day")
          : eventData.date
            ? moment(eventData.date).startOf("day")
            : null;

      const newDateForComparison = moment(eventDate).startOf("day");
      const dateActuallyChanged = originalDateForComparison
        ? !originalDateForComparison.isSame(newDateForComparison, "day")
        : dateChangedResult.startDateChanged;

      // For editType 2 (thisAndFutureEvent) or 3 (allEvent), if only time changed (same date),
      // IsEventDateChange should be false
      const finalIsEventDateChange =
        (editType === editTypesVariables.thisAndFutureEvent ||
          editType === editTypesVariables.allEvent) &&
        !dateActuallyChanged
          ? false
          : dateActuallyChanged;

      const params = {
        SchedulerEventId: eventData.id,
        OwnerId: selectedOwnerId,
        Title: eventData.title,
        Date: moment(
          requestedDateForDateCalc &&
            moment(requestedDateForDateCalc)
              .startOf("day")
              .isSame(moment(eventDate).startOf("day"))
            ? eventData?.date
            : eventDate,
        ).format("YYYY-MM-DDTHH:mm"),
        StartTime: newDateTime.newStartTimeString,
        EndTime: newDateTime.newEndTimeString,
        IsAllDayEvent: eventData.isAllDayEvent || false,
        RepeatedType: eventData.repeatedType || 1,
        RepeatedDay: moment(newDateTime.newDate).isoWeekday(),
        RepeatedEndDate:
          eventData.repeatedType > 1 && eventData.repeatedEndDate
            ? moment(eventData.repeatedEndDate).format("YYYY-MM-DD")
            : null,
        Location: eventData.location || "",
        BlockForPatient: eventData.blockForPatient || false,
        Note: eventData.note || "",
        PublishAsEvent: eventData.publishAsEvent || false,
        eventEmployees: Array.isArray(eventData.eventEmployees)
          ? eventData.eventEmployees
          : [],
        EventRoles: Array.isArray(eventData.eventRoles)
          ? eventData.eventRoles
          : [],
        EventTags: Array.isArray(eventData.eventTags)
          ? eventData.eventTags
          : [],
        CreatedAt: moment().format("YYYY-MM-DDTHH:mm"),
        ReminderBeforeInMins: eventData.reminderBeforeInMins || 0,
        isDraft: eventData.isDraft || false,
        requestedDate: originalRequestedDateForParams,
        timezoneCode: eventData.timezoneCode || moment.tz.guess(),
        EditType: editType || editTypesVariables.allEvent,
        UpdateFlags: {
          isTitleEdit: false,
          isStartTimeEdit: startTimeChanged,
          isEndTimeEdit: endTimeChanged,
          isAllDayEventEdit: false,
          isNoteEdit: false,
          isLocationEdit: false,
          isReminderBeforeInMinsEdit: false,
          isEnterpriseEdit: false,
          isOfficeIdEdit: false,
          EmployeeIds: [],
          RoleIds: [],
          IsRepeatTypeChange: false,
          IsEventDateChange: finalIsEventDateChange,
          IsRepeatedEndDateChange: dateChangedResult.endDateChanged,
          IsBlockForPatientChange: false,
          tagsIds: false,
        },
      };

      if (eventData.isShift) {
        params.Title = eventData.title || "";
        delete params.Location;
        delete params.Note;
        if (
          Array.isArray(eventData.eventEmployees) &&
          eventData.eventEmployees.length > 0 &&
          eventData.eventEmployees[0]
        ) {
          params.officeId = eventData.eventEmployees[0].officeId || null;
        }
      } else {
        params.IsAutoApprove = eventData.isAutoApprove || false;
      }

      try {
        setterCustomSchduler({
          params,
          repeatedType: eventData.repeatedType || 1,
          repeatedTypeFrequency: eventData.customRepeatPattern?.unit || 1,
          repeatedTypeEvery: eventData.customRepeatPattern?.interval || 1,
          selectionType: true,
          schedule:
            eventData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) || [],
          selectedSlotDate:
            eventData.customRepeatPattern?.daysOfMonth?.map((d) => d?.day) ||
            [],
          selectedWeek: eventData.customRepeatPattern?.monthWeekNumber || 1,
          selectedDay:
            eventData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) || [],
          selectedMonths:
            eventData.customRepeatPattern?.monthsOfYear?.map((m) => m?.month) ||
            [],
          isDaySwitchOn: false,
          edit: true,
          eventDetail: eventData,
        });
      } catch (error) {
        console.warn("Error in setterCustomSchduler:", error);
      }

      try {
        const preferredOption = {
          dropdown: eventData.publishAsEvent
            ? [{ id: "allowInvitees" }]
            : eventData.isDraft
              ? [{ id: "saveDraft" }]
              : [{ id: "inviteesOnly" }],
          otherOptions: [],
        };
        setterPublishOffices({
          preferredOption,
          userIds: Array.isArray(eventData.eventEmployees)
            ? eventData.eventEmployees
            : [],
          publishAsEvent: eventData.publishAsEvent
            ? "allowInvitees"
            : eventData.isDraft
              ? "saveDraft"
              : "inviteesOnly",
          nonInviteesPublish: eventData.publishedType || "allOffices",
          params,
          officeIdForNonInvitee: Array.isArray(
            eventData.schedulerEventPublishedOffices,
          )
            ? eventData.schedulerEventPublishedOffices.filter(
                (office) => office && office.id,
              )
            : [],
          edit: true,
          isDraft: eventData.isDraft || false,
        });
      } catch (error) {
        console.warn("Error in setterPublishOffices:", error);
      }

      await createSchedulerEventMutation.mutateAsync(params);

      // Refresh the event list
      getNotes(currentDate);

      toast.success(t("staff.eventUpdated"));
    },
    [
      selectedOwnerId,
      createSchedulerEventMutation,
      t,
      getTimeCheck,
      currentDate,
    ],
  );

  // Update event/shift via API (with EditEvent-style checks and modal)
  const updateEventAfterDrag = useCallback(
    async (eventItem, newDateTime, editType = null) => {
      if (!newDateTime || !eventItem || !eventItem.id) {
        toast.error(t("scheduler.invalidEventData"));
        return;
      }

      try {
        const originalRequestedDate = moment(
          draggedEventRef.current ||
            draggedEvent?.date ||
            eventItem.startTime ||
            newDateTime.newDate,
        ).format("YYYY-MM-DD");
        const eventDetails = await getEventListDetails(
          eventItem.id,
          originalRequestedDate,
        );
        const eventData = eventDetails?.data;

        if (!eventData) {
          toast.error(t("scheduler.eventNotFound"));
          return;
        }

        const dateChangedResult = matchedBothDatesValues({
          eventDetail: eventData,
          repeatedEndDate: eventData.repeatedEndDate
            ? moment(eventData.repeatedEndDate).toDate()
            : moment().add(3, "month").toDate(),
          requestedDate: originalRequestedDate,
          eventDate: newDateTime.newDate,
        });

        const repeatedOptionChanged = matchedBothPatternValues({
          repeatedType: eventData.repeatedType || 1,
          repeatedTypeFrequency: eventData.customRepeatPattern?.unit || 1,
          repeatedTypeEvery: eventData.customRepeatPattern?.interval || 1,
          selectionType: true,
          schedule:
            eventData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) || [],
          selectedSlotDate:
            eventData.customRepeatPattern?.daysOfMonth?.map((d) => d?.day) ||
            [],
          selectedWeek: eventData.customRepeatPattern?.monthWeekNumber || 1,
          selectedDay:
            eventData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) || [],
          selectedMonths:
            eventData.customRepeatPattern?.monthsOfYear?.map((m) => m?.month) ||
            [],
          isDaySwitchOn: false,
          edit: true,
          eventDetail: eventData,
        });

        const anyChangedForDate = repeatedOptionChanged;

        const startTimeChanged = getTimeCheck(
          eventData.startTime,
          newDateTime.newStartTimeString,
        );
        const endTimeChanged = getTimeCheck(
          eventData.endTime,
          newDateTime.newEndTimeString,
        );

        const hasChanges =
          dateChangedResult.startDateChanged ||
          dateChangedResult.endDateChanged ||
          startTimeChanged ||
          endTimeChanged;

        const neverCheck =
          eventData.repeatedType ===
          addEditEventsConst.repeatedOptionsValues.never;
        if (!neverCheck && eventData.repeatedEndDate) {
          const newDateStr = moment(newDateTime.newDate).format("YYYY-MM-DD");
          const repeatedEndDateStr = moment(eventData.repeatedEndDate).format(
            "YYYY-MM-DD",
          );
          if (
            !moment(newDateStr).isBefore(repeatedEndDateStr) &&
            newDateStr !== repeatedEndDateStr
          ) {
            toast.error(t("form.errors.endGreater"));
            return;
          }
        }

        const isNotDrafted = !eventData.isDraft;

        if (!neverCheck && !editType && hasChanges && isNotDrafted) {
          setPendingDragUpdate({
            eventData,
            newDateTime,
            anyChangedForDate,
            originalRequestedDate,
          });
          setEditModalConfirmation(true);
          return;
        }

        let finalEditType = editType;
        if (!finalEditType) {
          if (neverCheck) {
            finalEditType = editTypesVariables.allEvent;
          } else {
            finalEditType = editTypesVariables.allEvent;
          }
        }

        await performEventUpdate(
          eventData,
          newDateTime,
          finalEditType,
          originalRequestedDate,
        );
      } catch (error) {
        toast.error(error.message || t("scheduler.updateFailed"));
        throw error;
      }
    },
    [t, getTimeCheck, performEventUpdate, draggedEvent],
  );

  // Handle drag start
  const handleDragStart = useCallback(
    (e, eventItem, originalDateKey = null) => {
      if (!canDragEvent(eventItem)) {
        e.preventDefault();
        return;
      }

      const rect = e.currentTarget.getBoundingClientRect();
      const offsetX = e.clientX - rect.left;
      const offsetY = e.clientY - rect.top;

      let originalDate = null;
      if (originalDateKey) {
        const dayData = filteredData.find(
          (d) => moment(d.date).format("MMM DD, ddd") === originalDateKey,
        );
        if (dayData) {
          originalDate = moment(dayData.date).startOf("day");
        } else {
          const parsedDate = moment(originalDateKey, "MMM DD, ddd");
          if (parsedDate.isValid()) {
            const currentYear = moment().year();
            originalDate = parsedDate.year(currentYear).startOf("day");
          }
        }
      }

      if (!originalDate) {
        if (eventItem.date) {
          originalDate = moment(eventItem.date).startOf("day");
        } else if (eventItem.startTime) {
          originalDate = moment(eventItem.startTime).startOf("day");
        }
      }

      setDraggedEvent({
        eventItem,
        originalDate: originalDate ? originalDate.format("YYYY-MM-DD") : null,
        date: originalDateKey
          ? moment(originalDateKey).format("YYYY-MM-DD")
          : null,
      });
      draggedEventRef.current = originalDateKey
        ? moment(originalDateKey).format("YYYY-MM-DD")
        : null;
      setIsDragging(true);

      const dragImage = e.currentTarget.cloneNode(true);
      dragImage.style.opacity = "0";
      dragImage.style.position = "absolute";
      dragImage.style.top = "-1000px";
      document.body.appendChild(dragImage);
      e.dataTransfer.setDragImage(dragImage, offsetX, offsetY);
      setTimeout(() => document.body.removeChild(dragImage), 0);
    },
    [canDragEvent, filteredData],
  );

  // Handle drag over
  const handleDragOver = useCallback(
    (e, dayIndex, hourIndex, isAllDayRow = false) => {
      if (!draggedEvent) {
        e.preventDefault();
        return;
      }

      const { eventItem } = draggedEvent;
      const isDraggedAllDay = isAllDayEvent(eventItem);

      if (isDraggedAllDay && !isAllDayRow) {
        e.preventDefault();
        e.dataTransfer.dropEffect = "none";
        setDragPreviewPosition(null);
        return;
      }
      if (!isDraggedAllDay && isAllDayRow) {
        e.preventDefault();
        e.dataTransfer.dropEffect = "none";
        setDragPreviewPosition(null);
        return;
      }

      e.preventDefault();
      e.dataTransfer.dropEffect = "move";

      if (!isAllDayRow && !isDraggedAllDay && hourIndex !== undefined) {
        const cellElement = e.currentTarget;
        const cellRect = cellElement.getBoundingClientRect();
        const relativeY = e.clientY - cellRect.top;
        const cellHeight = cellRect.height;
        const minuteHeight = cellHeight / 60;
        const minutesFromHourStart = relativeY / minuteHeight;
        const exactMinutes = Math.round(minutesFromHourStart);
        const clampedMinute = snapTo15Minutes(exactMinutes);

        const originalStart = moment(eventItem.startTime);
        const originalEnd = moment(eventItem.endTime);
        const durationMinutes = originalEnd.diff(originalStart, "minutes");

        const topPercent = (clampedMinute / 60) * 100;
        const heightPercent = (durationMinutes / 60) * 100;

        setDragPreviewPosition({
          dayIndex,
          hourIndex,
          topPercent,
          heightPercent,
          clampedMinute,
        });
      } else if (isAllDayRow && isDraggedAllDay) {
        setDragPreviewPosition({
          dayIndex,
          isAllDay: true,
        });
      }
    },
    [draggedEvent, isAllDayEvent, snapTo15Minutes],
  );

  // Handle drop
  const handleDrop = useCallback(
    async (e, dayIndex, hourIndex, isAllDayRow = false) => {
      e.preventDefault();
      if (!draggedEvent || !draggedEvent.eventItem) {
        setIsDragging(false);
        setDraggedEvent(null);
        setDragPreviewPosition(null);
        return;
      }

      const { eventItem } = draggedEvent;
      if (!eventItem) {
        setIsDragging(false);
        setDraggedEvent(null);
        setDragPreviewPosition(null);
        return;
      }

      const isDraggedAllDay = isAllDayEvent(eventItem);

      if (isDraggedAllDay && !isAllDayRow) {
        toast.error(t("scheduler.cannotMoveAllDayToTimeBased"));
        setIsDragging(false);
        setDraggedEvent(null);
        setDragPreviewPosition(null);
        return;
      }
      if (!isDraggedAllDay && isAllDayRow) {
        toast.error(t("scheduler.cannotMoveTimeBasedToAllDay"));
        setIsDragging(false);
        setDraggedEvent(null);
        setDragPreviewPosition(null);
        return;
      }

      if (isAllDayRow && isDraggedAllDay) {
        if (!eventItem || !eventItem.id) {
          toast.error(t("scheduler.invalidEventData"));
          setIsDragging(false);
          setDraggedEvent(null);
          setDragPreviewPosition(null);
          return;
        }

        const newDate = calculateNewDateForAllDay(
          eventItem,
          dayIndex,
          draggedEvent.originalDate,
        );
        if (!newDate) {
          setIsDragging(false);
          setDraggedEvent(null);
          return;
        }

        setIsDragDropLoading(true);
        try {
          await updateEventAfterDrag(eventItem, newDate);
        } catch (error) {
          // Error already shown in update functions
        } finally {
          setIsDragDropLoading(false);
          setIsDragging(false);
          setDraggedEvent(null);
          setDragPreviewPosition(null);
        }
        return;
      }

      if (!eventItem || !eventItem.id) {
        toast.error("Invalid event data");
        setIsDragging(false);
        setDraggedEvent(null);
        setDragPreviewPosition(null);
        return;
      }

      const cellElement = e.currentTarget;
      const newDateTime = calculateNewDateTime(
        eventItem,
        e.clientX,
        e.clientY,
        cellElement,
        dayIndex,
        hourIndex,
      );

      if (newDateTime && newDateTime.error === "timeRangeExceeded") {
        toast.error("You can't move the event outside the time range");
        setIsDragging(false);
        setDraggedEvent(null);
        setDragPreviewPosition(null);
        return;
      }

      if (!newDateTime) {
        setIsDragging(false);
        setDraggedEvent(null);
        setDragPreviewPosition(null);
        return;
      }

      // Check if dropped on same time AND same date - if so, don't call API
      if (eventItem.startTime && newDateTime.newStartTime) {
        const originalStartTime = moment(eventItem.startTime);
        const newStartTime = moment(newDateTime.newStartTime);
        const targetDate = weekData[dayIndex];
        const originalDate = originalStartTime.startOf("day");
        const newDate = targetDate
          ? moment(targetDate.date).startOf("day")
          : null;

        if (
          newDate &&
          originalDate.isSame(newDate, "day") &&
          originalStartTime.hour() === newStartTime.hour() &&
          originalStartTime.minute() === newStartTime.minute()
        ) {
          setIsDragging(false);
          setDraggedEvent(null);
          setDragPreviewPosition(null);
          return;
        }
      }

      setIsDragDropLoading(true);
      try {
        await updateEventAfterDrag(eventItem, newDateTime);
      } catch (error) {
        // Error already shown in update functions
      } finally {
        setIsDragDropLoading(false);
        setIsDragging(false);
        setDraggedEvent(null);
        setDragPreviewPosition(null);
      }
    },
    [
      draggedEvent,
      isAllDayEvent,
      calculateNewDateTime,
      calculateNewDateForAllDay,
      updateEventAfterDrag,
      t,
      weekData,
    ],
  );

  // Handle drag end
  const handleDragEnd = useCallback(() => {
    if (!isDragDropLoading) {
      setIsDragging(false);
      setDraggedEvent(null);
      setDragPreviewPosition(null);
    }
  }, [isDragDropLoading]);

  const toggleEmpPopup = useCallback(
    async (e, item, dayMoment) => {
      try {
        e.stopPropagation();
        const targetRect = e.currentTarget.getBoundingClientRect(); // Capture rect

        setEmpPopupActive({});
        setIsLoading(true);
        const schedularEventDate = dayMoment.format("YYYY-MM-DD");
        const res = await getAssignedEmployess(
          item.id,
          schedularEventDate,
          selectedEmpFilter,
        );
        setEmpPopupActive({
          data: res.data || [],
          date: dayMoment.format("YYYY-MM-DDTHH:mm:ss"),
          id: item.id,
          position: {
            top: targetRect.bottom + window.scrollY,
            left: targetRect.left + window.scrollX,
            height: targetRect.height, // Added height for dynamic vertical positioning
          },
        });
      } catch (err) {
        handleError(err);
      }
      setIsLoading(false);
    },
    [selectedEmpFilter],
  );

  // Unified Render Event Function with Dropdown
  const renderEvent = (
    event,
    dynamicStyles,
    dayMoment,
    dayIndex = null,
    originalDateKey = null,
    isDragPreview = false,
  ) => {
    const themeClass = getEventThemeClass(event);
    const createdByOthers =
      event?.isShift && profile?.id !== event?.createdById;

    // Check permission for card action menu
    const canShowEventMenu =
      !isDragPreview &&
      canShowEventCardMenu(event, profile, {
        isOwner,
        canEditAndViewOthersData,
      });

    const moveToDetailPage = (e) => {
      if (e.target.closest(".interactive-dropdown")) return;
      history.push({
        pathname: constants.routes.scheduler.eventDetails.replace(
          ":eventId",
          encodeId(event.id),
        ),
        state: { requestedDate: dayMoment.format("YYYY-MM-DD") },
        search: effectiveOwnerIdString ? `?${effectiveOwnerIdString}` : "",
      });
    };

    const canDrag = canDragEvent(event) && !bulkSelectMode;
    const isDragged =
      isDragging && draggedEvent?.eventItem?.id === event.id && !isDragPreview;
    const selectionDate = dayMoment.format("YYYY-MM-DD");
    const selectionKey = getEventShiftSelectionKey(event.id, selectionDate);
    const eventMenuKey = `${event.id}_${selectionDate}_${
      event?.isAllDayEvent ? "allday" : "timed"
    }_${isDragPreview ? "preview" : "card"}`;
    const isEventSelected = isEventShiftSelected(
      selectedEvents,
      event.id,
      selectionDate,
    );

    return (
      <div
        key={event.id}
        className={`${weeklyStyles["event-card"]} ${weeklyStyles[themeClass]}${
          bulkSelectMode ? ` ${weeklyStyles["bulk-select-event-card"]}` : ""
        }`}
        style={{
          ...dynamicStyles,
          backgroundColor: event?.isDraft ? "#FEF3D7" : "",
          cursor: canDrag ? "grab" : "pointer",
          opacity: isDragged
            ? 0
            : dynamicStyles?.opacity !== undefined
              ? dynamicStyles.opacity
              : 1,
          zIndex: isDragged ? 1000 : 2,
        }}
        draggable={canDrag}
        onDragStart={(e) => handleDragStart(e, event, originalDateKey)}
        onDragEnd={handleDragEnd}
        onDragOver={(e) => {
          // When dragging over event cards, calculate exact position and update drag preview
          // This allows dragging within the same hour (e.g., 1am to 1:05am)
          if (isDragging && draggedEvent && dayIndex !== null) {
            const dayColumnBody = e.currentTarget.closest(
              `.${weeklyStyles["day-column-body"]}`,
            );
            if (dayColumnBody) {
              const dayColumnRect = dayColumnBody.getBoundingClientRect();
              const relativeY = e.clientY - dayColumnRect.top;
              const hourIndex = Math.floor(relativeY / HOUR_HEIGHT);

              if (hourIndex >= 0 && hourIndex < hours.length) {
                e.preventDefault();
                e.stopPropagation();
                e.dataTransfer.dropEffect = "move";

                // Calculate minute position within the hour and snap to 15-minute intervals
                const hourStartY = hourIndex * HOUR_HEIGHT;
                const relativeYInHour = relativeY - hourStartY;
                const minuteHeight = HOUR_HEIGHT / 60;
                const minutesFromHourStart = relativeYInHour / minuteHeight;
                const exactMinutes = Math.round(minutesFromHourStart);
                const clampedMinute = snapTo15Minutes(exactMinutes);

                const { eventItem } = draggedEvent;
                const originalStart = moment(eventItem.startTime);
                const originalEnd = moment(eventItem.endTime);
                const durationMinutes = originalEnd.diff(
                  originalStart,
                  "minutes",
                );

                const topPercent = (clampedMinute / 60) * 100;
                const heightPercent = (durationMinutes / 60) * 100;

                setDragPreviewPosition({
                  dayIndex,
                  hourIndex,
                  topPercent,
                  heightPercent,
                  clampedMinute,
                });
              }
            }
          }
        }}
        onDrop={(e) => {
          // Handle drop on event cards - calculate exact position and drop
          if (isDragging && draggedEvent && dayIndex !== null) {
            const dayColumnBody = e.currentTarget.closest(
              `.${weeklyStyles["day-column-body"]}`,
            );
            if (dayColumnBody) {
              const dayColumnRect = dayColumnBody.getBoundingClientRect();
              const relativeY = e.clientY - dayColumnRect.top;
              const hourIndex = Math.floor(relativeY / HOUR_HEIGHT);

              if (hourIndex >= 0 && hourIndex < hours.length) {
                e.preventDefault();
                e.stopPropagation();

                // Find the grid-line element for this hour to use calculateNewDateTime
                const gridLines = dayColumnBody.querySelectorAll(
                  `.${weeklyStyles["grid-line"]}`,
                );
                if (gridLines[hourIndex]) {
                  // Use calculateNewDateTime with the grid-line element and client coordinates
                  // This ensures proper validation and exact minute calculation
                  const newDateTime = calculateNewDateTime(
                    draggedEvent.eventItem,
                    e.clientX,
                    e.clientY,
                    gridLines[hourIndex],
                    dayIndex,
                    hourIndex,
                  );

                  if (!newDateTime) {
                    setIsDragging(false);
                    setDraggedEvent(null);
                    setDragPreviewPosition(null);
                    return;
                  }

                  if (newDateTime.error) {
                    if (newDateTime.error === "timeRangeExceeded") {
                      toast.error(
                        t("You can't move the event outside the time range"),
                      );
                    }
                    setIsDragging(false);
                    setDraggedEvent(null);
                    setDragPreviewPosition(null);
                    return;
                  }

                  // Use the same drop logic
                  setIsDragDropLoading(true);
                  updateEventAfterDrag(draggedEvent.eventItem, newDateTime)
                    .catch(() => {
                      // Error already shown in update function
                    })
                    .finally(() => {
                      setIsDragDropLoading(false);
                      setIsDragging(false);
                      setDraggedEvent(null);
                      setDragPreviewPosition(null);
                    });
                }
              }
            }
          }
        }}
        onClick={(e) => {
          if (isDragging) {
            e.stopPropagation();
            return;
          }
          if (e.target.closest(".interactive-dropdown")) return;
          if (bulkSelectMode) {
            handleEventSelectionToggle(selectionKey, {
              id: event.id,
              date: dayMoment.format("YYYY-MM-DD"),
              isDraft: event.isDraft,
              isShift: Boolean(event.isShift),
              publishAsEvent: event.publishAsEvent,
              userId: null,
              isUnassigned: isUnassignedSchedulerEvent(event),
            });
            return;
          }
          moveToDetailPage(e);
        }}
      >
        {bulkSelectMode && (
          <div
            className={`ch-checkbox ${styles["bulk-select-checkbox"]}`}
            onClick={(e) => e.stopPropagation()}
          >
            <label>
              <input
                type="checkbox"
                checked={isEventSelected}
                onChange={() =>
                  handleEventSelectionToggle(selectionKey, {
                    id: event.id,
                    date: dayMoment.format("YYYY-MM-DD"),
                    isDraft: event.isDraft,
                    isShift: Boolean(event.isShift),
                    publishAsEvent: event.publishAsEvent,
                    userId: null,
                    isUnassigned: isUnassignedSchedulerEvent(event),
                  })
                }
              />
              <span />
            </label>
          </div>
        )}
        <div
          className={weeklyStyles["badges-row"]}
          style={{ alignItems: "center", justifyContent: "space-between" }}
        >
          {(!viewSettingFilter.length || viewSettingFilter.includes("tag")) && (
            <div style={{ display: "flex", gap: "4px", flexWrap: "wrap" }}>
              {event.isDraft && (
                <span
                  className={`${weeklyStyles["badge"]} ${styles["draft-warning-bg"]}`}
                >
                  DRAFT
                </span>
              )}
              <span
                className={`${weeklyStyles["badge"]} ${weeklyStyles["type-badge"]} ${event.isDraft ? styles["theme-green-bg"] : ""}`}
              >
                {themeClass === "theme-orange"
                  ? "BUSY"
                  : event.isShift
                    ? createdByOthers
                      ? t("scheduler.agenda.shiftByOthers")
                      : "SHIFT"
                    : "EVENT"}
              </span>
            </div>
          )}

          {/* Dropdown Menu - Now part of renderEvent for all cards */}
          {canShowEventMenu && (
            <Dropdown
              isOpen={openEventMenuKey === eventMenuKey}
              toggle={createEventMenuToggleHandler(eventMenuKey)}
              onClick={(e) => e.stopPropagation()}
              className={`interactive-dropdown ${weeklyStyles["interactive-events-dropdown"]}`}
            >
              <DropdownToggle
                tag="div"
                className="cursor-pointer d-flex align-items-center"
              >
                <ThreeDots size={14} color="#6B7280" />
              </DropdownToggle>
              <DropdownMenu
                className={styles["office-dropdown-menu"]}
                end
                container="body"
              >
                <DropdownItem
                  className={styles["office-dropdown-item"]}
                  onClick={(e) => {
                    e.stopPropagation();
                    onDuplicateEvent(event, dayMoment, 1);
                  }}
                >
                  <span>
                    {t("scheduler.duplicateEvent", {
                      eventOrShiftOrLeave: event?.isShift
                        ? t("accountOwner.shiftTab")
                        : t("accountOwner.eventTab"),
                    })}
                  </span>
                </DropdownItem>
                <DropdownItem
                  className={styles["office-dropdown-item"]}
                  toggle={false}
                  onClick={handleMultipleDuplicatesClick(
                    eventMenuKey,
                    event,
                    dayMoment,
                  )}
                >
                  <span>{t("scheduler.multipleDuplicates")}</span>
                </DropdownItem>
                <DropdownItem
                  className={styles["office-dropdown-item"]}
                  onClick={(e) => {
                    e.stopPropagation();
                    openAssignUsersModal(event, dayMoment);
                  }}
                >
                  <span>{t("scheduler.assignStaff")}</span>
                </DropdownItem>
                {/* <DropdownItem
                  className={styles["office-dropdown-item"]}
                  onClick={(e) => {
                    e.stopPropagation();
                    showComingSoon(t("scheduler.unassignUsers"));
                  }}
                >
                  <span>{t("scheduler.unassignUsers")}</span>
                </DropdownItem> */}
                <DropdownItem
                  className={styles["office-dropdown-item"]}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCardDeleteClick(
                      event,
                      dayMoment.format("YYYY-MM-DD"),
                      {
                        selectedUserIdsFromStaffView: event?.userId
                          ? [event.userId]
                          : [],
                        lockSelectedUsers: Boolean(event?.userId),
                      },
                      {
                        search: effectiveOwnerIdString
                          ? `?${effectiveOwnerIdString}`
                          : "",
                      },
                    );
                  }}
                >
                  <span style={{ color: "#EE4F4F" }}>
                    {t("scheduler.deleteEvent", {
                      eventOrShift: event?.isShift
                        ? t("accountOwner.shiftTab")
                        : t("accountOwner.eventTab"),
                    })}
                  </span>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          )}
        </div>

        {(!viewSettingFilter.length ||
          viewSettingFilter.includes("timeString")) && (
          <div className={weeklyStyles["event-date"]}>
            {event?.isAllDayEvent
              ? t("scheduler.agenda.allDayEvent")
              : event?.startTime && event?.endTime
                ? moment(event?.startTime).format("h:mm A") +
                  " - " +
                  moment(event?.endTime).format("h:mm A")
                : ""}
          </div>
        )}

        {(!viewSettingFilter.length ||
          viewSettingFilter.includes("officeName")) && (
          <div className={weeklyStyles["event-office-name"]}>
            {renderOfficeNameOrEnterprise(event, t)}
          </div>
        )}

        {(!viewSettingFilter.length || viewSettingFilter.includes("title")) &&
          themeClass !== "theme-orange" && (
            <div className={weeklyStyles["event-title"]}>
              {titleWordLimit(
                event?.agendaType === constants.agendaType.LEAVE
                  ? "On Leave"
                  : event?.agendaType === constants.agendaType.APPOINTMENT
                    ? "Patient Appointment"
                    : event.title,
              )}
            </div>
          )}

        {(!viewSettingFilter.length ||
          viewSettingFilter.includes("assignedEmployees")) &&
          !isDragPreview &&
          (event?.modifiedEmployeeCount > 0 ||
            event?.eventEmployeeCount > 0) && (
            <div
              className="interactive-element"
              onClick={(e) =>
                event?.eventEmployeeCount > 1 &&
                toggleEmpPopup(e, event, dayMoment)
              }
            >
              {event?.modifiedEmployeeCount > 1 ||
              !event?.modifiedEmployeeCount ? (
                <span className="link-btn">
                  {`${event?.modifiedEmployeeCount || 0} Employees`}
                </span>
              ) : (
                <span className="link-btn-without-underline">
                  {event?.eventEmployeeUsers}
                </span>
              )}
            </div>
          )}

        {!isDragPreview &&
          dateFormater(isEmpPopActive?.date) === dateFormater(dayMoment) &&
          isEmpPopActive.id === event.id &&
          ReactDOM.createPortal(
            <div
              ref={popupRef}
              className={styles["employee-popup-box"]}
              style={{
                position: "absolute",
                top: isEmpPopActive.position?.top,
                left: isEmpPopActive.position?.left,
                zIndex: 1050,
                width: "max-content",
              }}
            >
              <span
                className={styles["close-icon"]}
                onClick={(e) => {
                  e.stopPropagation();
                  setEmpPopupActive("");
                }}
              >
                &times;
              </span>
              <div className={styles["emp-data-list"]}>
                {isEmpPopActive?.data?.map((e, __index) => (
                  <div className={styles["emp-data"]} key={__index}>
                    <Row className={styles["row-box"]}>
                      <Text
                        size="14px"
                        color="#587E85"
                        weight="600"
                        paddingLeft="5px"
                      >
                        {e?.user?.firstName} {e?.user?.lastName}{" "}
                      </Text>
                      <div className={styles.clinic_role_status_wrapper}>
                        <Text size="12px" color="#2F3245" weight="500">
                          {e?.office?.name}
                        </Text>
                        <span className={styles.bullet_text}>
                          <Text size="12px" color="#2F3245" weight="500">
                            {e?.user?.role?.systemRole === 2
                              ? e?.user?.role?.name
                                ? e?.user?.role?.name
                                : "--"
                              : e?.user?.designation?.name
                                ? e?.user?.designation?.name
                                : "--"}
                          </Text>
                        </span>
                        <span className={styles.bullet_text}>
                          <p className={styles.status_text}>
                            {t(getSchedulerStatusById(e?.status))}
                          </p>
                        </span>
                      </div>
                    </Row>
                  </div>
                ))}
              </div>
            </div>,
            document.body,
          )}
      </div>
    );
  };

  function updateList(data, type) {
    if (data && (type === "ADD" || type === "EDIT")) {
      const updated = [...weekData];
      if (updated[index]) {
        updated[index].note = true;
        updated[index].data = data.data;
      }
      setWeekData(updated);
    }
    if (type === "DELETE") {
      const updated = [...weekData];
      if (updated[index]) {
        updated[index].note = false;
        delete updated[index].data;
      }
      setWeekData(updated);
    }
  }

  function deleteNotesConfirm() {
    setdeleteConfirmation({ visible: false, id: "" });
    setIsLoading(true);
    deleteSchedularNote(deleteConfirmation.id)
      .then((res) => {
        if (res.statusCode === 200) {
          updateList("", "DELETE");
          toast.success(res?.message);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        setIsLoading(false);
        toast.error(e.message);
      });
  }

  function addNotesModelShow(data, type) {
    setIsAddNotesModal({
      visible: true,
      data,
      type,
      value: type === "EDIT" ? data.data.text : "",
    });
  }

  function editNotesModelShow(data) {
    setIsEditNotesModal({ visible: true, data });
  }

  function publishedEventConfirm(isPublish) {
    setIsLoading(true);
    eventPublished(eventId.id, isPublish)
      .then((res) => {
        setIsPublishEventModalOpen(false);
        getNotes(currentDate);
        handleSuccess(res.message);
      })
      .catch(handleError)
      .finally(() => setIsLoading(false));
  }

  function clostPublishEventModal() {
    setIsPublishEventModalOpen(false);
    setIsDraftPublishEvetntOpen(false);
  }

  useEffect(() => {
    if (!search || !filteredData?.length) return;
    if (divRef.current) {
      setTimeout(() => {
        divRef.current.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "center",
        });
      }, 500);
    }
    const timeOut = setTimeout(() => {
      const queryParams = new URLSearchParams(search);
      if (queryParams.has(showTime)) {
        queryParams.delete(showTime);
        history.replace({
          search: queryParams.toString(),
        });
      }
    }, 3000);
    return () => clearTimeout(timeOut);
  }, [search, filteredData, history]);

  return (
    <>
      {!isStaffNameWeeklyLayout &&
        (isLoading ||
          isEventLoading ||
          isDragDropLoading ||
          isBulkActionLoading ||
          isAssignLoading) && <Loader />}

      {isStaffNameWeeklyLayout ? (
        <EventsShiftsWeeklyByStaff
          currentDate={currentDate}
          selectedOfficeFilter={selectedOfficeFilter}
          selectedEmpFilter={selectedEmpFilter}
          searchValue={searchValue}
          isSidebarActive={isSidebarActive}
          viewSettingFilter={viewSettingFilter}
          eventShiftFilter={eventShiftFilter}
          isEnterpriseFilterActive={isEnterpriseFilterActive}
          appliedPublishedDraftFilter={appliedPublishedDraftFilter}
          setcurrentDate={setcurrentDate}
          upDateListonApply={upDateListonApply}
          bulkSelectMode={bulkSelectMode}
          selectedEvents={selectedEvents}
          isBulkActionLoading={isBulkActionLoading}
          handleEventSelectionToggle={handleEventSelectionToggle}
          handleSelectableEventsUpdate={handleSelectableEventsUpdate}
          onVisibleDraftEventsUpdate={onVisibleDraftEventsUpdate}
          onVisibleClearableItemsUpdate={onVisibleClearableItemsUpdate}
          settotalEvents={settotalEvents}
          canAddShift={canAddShift}
          sortStaffBy={sortStaffBy}
        />
      ) : (
        <div
          ref={scrollContainerRef}
          className={weeklyStyles["weekly-schedular-calendar-styles"]}
          style={{
            maxHeight: tableHeight,
            overflowY: "auto",
            position: "relative",
          }}
        >
          <div
            className={weeklyStyles["header-row"]}
            ref={headerRef} // Attached ref for the specific row to make sticky
            style={{
              position: "sticky",
              top: 0,
              zIndex: 105,
              backgroundColor: "#ffffff",
            }}
          >
            <div className={weeklyStyles["time-placeholder"]}></div>

            {days.map((day, i) => {
              const dayMoment =
                day.momentDate || moment(day.date, "MMM DD, ddd");
              const isToday = moment().isSame(dayMoment, "day");
              const highlightCheck =
                dateMatchForHighlight &&
                moment(dateMatchForHighlight).isSame(dayMoment, "day");
              const dayNoteData = filteredData.find(
                (d) => moment(d.date).format("MMM DD, ddd") === day.date,
              );

              return (
                <div
                  key={i}
                  className={`${weeklyStyles["day-column-header"]} ${
                    isToday ? weeklyStyles["today"] : ""
                  }${highlightCheck ? " blinking-background" : ""}`}
                >
                  <div className={weeklyStyles["header-top"]}>
                    {dayNoteData?.note && (
                      <div className={weeklyStyles["note-wrapper"]}>
                        <NoteView
                          list={dayNoteData}
                          dateShow={dayMoment.format("ddd, MMM DD")}
                        />
                      </div>
                    )}
                    <span className={weeklyStyles["date-text"]}>
                      {dayMoment.format("ddd, MMM DD")}
                    </span>

                    <UncontrolledDropdown
                      className={`select-common-dropdown ${weeklyStyles["date-ellipse-menu"]} ${weeklyStyles["min-width-fix"]}`}
                    >
                      <DropdownToggle tag="div" className="cursor-pointer">
                        <ThreeDots color="#9CA3AF" />
                      </DropdownToggle>
                      <DropdownMenu end>
                        <DropdownItem
                          onClick={() =>
                            history.push(constants.routes.scheduler.addEvent, {
                              date: dayMoment.format("YYYY-MM-DD"),
                            })
                          }
                        >
                          <span>
                            {t(
                              canAddShift
                                ? "accountOwner.newEventShift"
                                : "accountOwner.newEvent",
                            )}
                          </span>
                        </DropdownItem>
                        <DropdownItem
                          onClick={() => {
                            setindex(i);
                            if (dayNoteData?.note)
                              editNotesModelShow(dayNoteData);
                            else addNotesModelShow(dayNoteData, "ADD");
                          }}
                        >
                          <span>
                            {dayNoteData?.note
                              ? t("accountOwner.viewNote")
                              : t("staff.addNote")}
                          </span>
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </div>
                </div>
              );
            })}
          </div>

          <div
            className={`${weeklyStyles["header-row"]} ${weeklyStyles["bg-transparent"]}`}
            style={{ minHeight: "40px" }}
          >
            <div className={weeklyStyles["time-placeholder"]}>all-day</div>

            {days.map((day, i) => {
              const dayMoment =
                day.momentDate || moment(day.date, "MMM DD, ddd");
              const dayDateStr = moment(day.momentDate).format("DD-MM-YYYY");
              const dateKey = day.date; // Use key from days mapping
              const isHoliday = holidaysObject[dayDateStr];
              const allDayEvents = allDayEventsByDate[dateKey] || [];

              return (
                <div
                  key={i}
                  className={`${weeklyStyles["day-column-header"]} ${weeklyStyles["bg-transparent"]} ${weeklyStyles["all-day-cell"]}`}
                  style={{
                    padding: allDayEvents.length > 0 ? "4px" : 0,
                    backgroundColor: isHoliday ? "#e7ecf0" : "transparent",
                    justifyContent: "start",
                    cursor: bulkSelectMode ? "default" : "pointer",
                  }}
                  onDragOver={(e) => handleDragOver(e, i, 0, true)}
                  onDrop={(e) => handleDrop(e, i, 0, true)}
                  onClick={(e) => {
                    if (bulkSelectMode || isDragging) return;
                    if (e.target !== e.currentTarget) return;
                    history.push(constants.routes.scheduler.addEvent, {
                      date: dayMoment.format("YYYY-MM-DD"),
                    });
                  }}
                >
                  {allDayEvents.map((event, eventIndex) => {
                    return (
                      <div key={eventIndex} style={{ marginBottom: "4px" }}>
                        {renderEvent(
                          event,
                          {
                            position: "relative",
                            marginBottom: 0,
                            width: "100%",
                          },
                          dayMoment,
                          i,
                          day?.momentDate,
                        )}
                      </div>
                    );
                  })}
                  {!bulkSelectMode &&
                    !isDragging &&
                    allDayEvents.length === 0 && (
                      <EmptySchedulerCellAdd
                        variant="circle"
                        ariaLabel={t(
                          canAddShift
                            ? "accountOwner.newEventShift"
                            : "accountOwner.newEvent",
                        )}
                        onClick={() =>
                          history.push(constants.routes.scheduler.addEvent, {
                            date: dayMoment.format("YYYY-MM-DD"),
                          })
                        }
                      />
                    )}
                  {/* Drag preview for all-day events */}
                  {isDragging &&
                    dragPreviewPosition &&
                    dragPreviewPosition.isAllDay &&
                    dragPreviewPosition.dayIndex === i &&
                    draggedEvent &&
                    draggedEvent.eventItem && (
                      <div
                        style={{
                          marginTop: "4px",
                          pointerEvents: "none",
                          border: "2px dashed #C8E364",
                          borderRadius: 4,
                          overflow: "hidden",
                        }}
                      >
                        {renderEvent(
                          draggedEvent.eventItem,
                          {
                            position: "relative",
                            cursor: "grab",
                            width: "100%",
                            marginBottom: 0,
                            opacity: 0.7,
                          },
                          dayMoment,
                          i,
                          day.momentDate,
                          true,
                        )}
                      </div>
                    )}
                </div>
              );
            })}
          </div>

          {hasAnyHoliday && (
            <div className={weeklyStyles["holiday-row"]}>
              <div className={weeklyStyles["time-placeholder"]}></div>

              {days.map((day, i) => {
                const dayDateStr = moment(day.momentDate).format("DD-MM-YYYY");
                const existingHoliday = holidaysObject[dayDateStr];
                const holidayList = existingHoliday
                  ? [{ title: existingHoliday }]
                  : [];

                return (
                  <div key={i} className={weeklyStyles["holiday-cell"]}>
                    {holidayList?.length > 0 && (
                      <div className={weeklyStyles["holiday-card"]}>
                        <img src={HolidayImage} alt="Holiday" />
                        {holidayList[0]?.title ?? "HOLIDAY"}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}

          <div className={weeklyStyles["body-container"]} ref={containerRef}>
            <div className={weeklyStyles["time-labels-column"]}>
              {hours.map((h, i) => (
                <div
                  key={i}
                  className={weeklyStyles["time-slot"]}
                  style={{ height: `${HOUR_HEIGHT}px` }}
                >
                  <span className={weeklyStyles["time-text"]}>{h.label}</span>
                </div>
              ))}
            </div>

            {days.map((day, dayIndex) => {
              const dayMoment =
                day.momentDate || moment(day.date, "MMM DD, ddd");
              const dayDateStr = dayMoment.format("DD-MM-YYYY");
              const isHoliday = holidaysObject[dayDateStr];
              const highlightCheck =
                dateMatchForHighlight &&
                moment(dateMatchForHighlight).isSame(dayMoment, "day");

              const dayEventsData = filteredData.find(
                (d) => moment(d.date).format("MMM DD, ddd") === day.date,
              );
              const events = (dayEventsData?.schedulerEvents || []).filter(
                (e) => isSchedulerTimedSlotEvent(e),
              );

              const positionedEvents = calculateOverlapPositions(events);

              return (
                <div
                  key={dayIndex}
                  ref={highlightCheck ? divRef : undefined}
                  className={`${weeklyStyles["day-column-body"]} ${
                    isHoliday ? weeklyStyles["holiday-bg"] : ""
                  }${highlightCheck ? " blinking-background" : ""}`}
                >
                  {hours.map((h, i) => (
                    <div
                      key={i}
                      className={weeklyStyles["grid-line"]}
                      style={{
                        height: `${HOUR_HEIGHT}px`,
                        position: "relative",
                        cursor: bulkSelectMode ? "default" : "pointer",
                      }}
                      onDragOver={(e) => handleDragOver(e, dayIndex, i, false)}
                      onDrop={(e) => handleDrop(e, dayIndex, i, false)}
                      onClick={() => {
                        if (bulkSelectMode || isDragging) return;
                        history.push(constants.routes.scheduler.addEvent, {
                          date: dayMoment.format("YYYY-MM-DD"),
                        });
                      }}
                    >
                      {!bulkSelectMode &&
                        !isDragging &&
                        !hourSlotHasEvent(events, h.hour) && (
                          <EmptySchedulerCellAdd
                            variant="circle"
                            ariaLabel={t(
                              canAddShift
                                ? "accountOwner.newEventShift"
                                : "accountOwner.newEvent",
                            )}
                            onClick={() =>
                              history.push(
                                constants.routes.scheduler.addEvent,
                                {
                                  date: dayMoment.format("YYYY-MM-DD"),
                                },
                              )
                            }
                          />
                        )}
                    </div>
                  ))}

                  {positionedEvents.map(
                    ({ event, widthFactor, leftOffsetFactor }) => {
                      const startMin = getTimeInMinutes(event.startTime);
                      const endMin = getTimeInMinutes(event.endTime);

                      const topPx = (startMin / 1440) * (24 * HOUR_HEIGHT);
                      const heightPx =
                        ((endMin - startMin) / 1440) * (24 * HOUR_HEIGHT);

                      const dynamicStyles = {
                        top: `${topPx}px`,
                        height: `${Math.max(heightPx, 44)}px`,
                        left: `calc(${leftOffsetFactor * 100}% + 2px)`,
                        width: `calc(${widthFactor * 100}% - 4px)`,
                      };

                      return renderEvent(
                        event,
                        dynamicStyles,
                        dayMoment,
                        dayIndex,
                        day.momentDate,
                      );
                    },
                  )}

                  {/* Drag preview for time-based events */}
                  {isDragging &&
                    dragPreviewPosition &&
                    !dragPreviewPosition.isAllDay &&
                    dragPreviewPosition.dayIndex === dayIndex &&
                    draggedEvent &&
                    draggedEvent.eventItem &&
                    dragPreviewPosition.hourIndex !== undefined && (
                      <div
                        style={{
                          position: "absolute",
                          top: `${
                            dragPreviewPosition.hourIndex * HOUR_HEIGHT +
                            (dragPreviewPosition.topPercent / 100) * HOUR_HEIGHT
                          }px`,
                          left: 0,
                          width: "100%",
                          height: `${
                            (dragPreviewPosition.heightPercent / 100) *
                            HOUR_HEIGHT
                          }px`,
                          backgroundColor:
                            getEventThemeClass(draggedEvent.eventItem) ===
                            "theme-orange"
                              ? "#fff9eb"
                              : getEventThemeClass(draggedEvent.eventItem) ===
                                  "theme-blue"
                                ? "#ebf8ff"
                                : "#C8E36433",
                          border: "2px dashed #C8E364",
                          borderRadius: 6,
                          opacity: 0.6,
                          zIndex: 1000,
                          pointerEvents: "none",
                          display: "flex",
                          alignItems: "center",
                          padding: "2px 4px",
                        }}
                      >
                        {renderEvent(
                          draggedEvent.eventItem,
                          {
                            position: "relative",
                            cursor: "grab",
                            width: "100%",
                            marginBottom: 0,
                            opacity: 0.7,
                          },
                          dayMoment,
                          dayIndex,
                          day.momentDate,
                          true,
                        )}
                      </div>
                    )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      <AddNotesModal
        isAddNotesModal={isAddNotesModal}
        setIsAddNotesModal={setIsAddNotesModal}
        updateList={updateList}
        setIsLoading={setIsLoading}
        getDetailsOwnerIfStaff={selectedOwnerId}
      />
      <EditNotesModal
        isEditNotesModal={isEditNotesModal}
        setIsEditNotesModal={setIsEditNotesModal}
        addNotesModelShow={addNotesModelShow}
        setdeleteConfirmation={setdeleteConfirmation}
      />
      <DeleteNotes
        isDeleteEventModalOpen={deleteConfirmation.visible}
        setIsDeleteEventModalOpen={setdeleteConfirmation}
        deleteNotesConfirm={deleteNotesConfirm}
        updateList={updateList}
      />
      {renderSimpleDeleteConfirmModal()}
      <PublishEventModal
        isLoader={isLoading}
        isPublishEventModalOpen={isPublishEventModalOpen}
        noOfEmployeeAssigne={noOfEmployeeAssigne}
        isDraftPublistEventOpen={isDraftPublistEventOpen}
        publishedEventConfirm={publishedEventConfirm}
        clostPublishEventModal={clostPublishEventModal}
      />
      {renderMultipleDuplicatesFlyout(onDuplicateEvent, t)}
      {renderAssignUsersModals()}
      {editModalConfirmation && pendingDragUpdate && (
        <EditOptionsModal
          isOpen={editModalConfirmation}
          closeStepOneModal={setEditModalConfirmation}
          loader={isDragDropLoading}
          eventKey={{
            eventOrShift: t(
              `accountOwner.${
                pendingDragUpdate.eventData?.isShift ? "shift" : "event"
              }Tab`,
            ).toLowerCase(),
          }}
          eventOrShiftTab={pendingDragUpdate.eventData?.isShift || false}
          busySlots={false}
          repeatedOptionChanged={pendingDragUpdate.anyChangedForDate || false}
          handleConfirm={async (value) => {
            setIsDragDropLoading(true);
            try {
              await performEventUpdate(
                pendingDragUpdate.eventData,
                pendingDragUpdate.newDateTime,
                value,
                pendingDragUpdate.originalRequestedDate,
              );
            } catch {
            } finally {
              setEditModalConfirmation(false);
              setPendingDragUpdate(null);
              setIsDragDropLoading(false);
            }
          }}
        />
      )}
    </>
  );
}

export default withTranslation()(EventsShiftsWeekly);
